// extracted by mini-css-extract-plugin
export default {"image":"b6-z","loaded":"c6-z"};